import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  userInfoTooltipContariner: {
    padding: '9px 16px',
    backgroundColor: theme.palette.background.paper,
    boxShadow: `0px 2px 6px 2px ${theme.palette.grey[400]}`,
    borderRadius: 5,
    width: 600,
    textAlign: 'left'
  },
  userInfoTooltipHeaderContainer: {},
  userInfoHeader: {
    paddingTop: 12,
    paddingBottom: 16
  },
  userInfoEachRow: {
    display: 'grid',
    gridTemplateColumns: '8fr 1fr 20fr',
    marginTop: 4,
    direction: 'ltr'
  },
  userInfoCell: {},
  userInfoEmail: {
    cursor: 'default'
  },
  userInfoColon: {
    paddingRight: 20,
    paddingLeft: 10,
    color: theme.palette.secondary.dark
  },
  userInformation: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  infoIcon: {
    marginLeft: 7,
    fontSize: 18
  }
}))
export default useStyles
